export default function NumberChart({ data, chartOptions }) {
  const { numberFunction, format = 'number' } = chartOptions
  if (numberFunction) {
    var number = numberFunction(data[0])
  } else {
    var number = _.values(data[0])[0]
  }

  if (format === 'percentage') {
    number = (number * 100).toFixed(1) + '%'
  } else if (format === 'currency') {
    number = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number)
  } else {
    number = number.toLocaleString()
  }

  return <div className='number-chart'>
    <div className="value">
      { number }
    </div>
    <div className='description'>{chartOptions.title}</div>
  </div>
}
